<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <div slot="right">
          <el-button
            :disabled="isLoading"
            :loading="isSaving"
            class="save-button"
            size="mini"
            type="danger"
            icon="el-icon-upload2"
            @click="handleSave"
          >
            {{ $t('button.save') }}
          </el-button>
        </div>
      </list-page-header>
    </template>

    <el-form
      v-loading="isLoading"
      ref="form"
      :disabled="isSaving"
      :model="productForm"
      class="round-border-form"
      label-position="top"
      label-width="200"
    >
      <div class="form-group">
        <el-form-item
          label="Product ID"
          prop="product_id"
        >
          <el-input
            v-model="productForm.product_id"
            clearable
          />
        </el-form-item>
      </div>
    </el-form>
  </sticky-header-layout>
</template>

<script>
export default {
  name: "RemoveProduct",
  data() {
    return {
      isLoading: false,
      isSaving: false,
      productForm: {
        product_id: '',
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/form.scss";
</style>
